import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var LoadingSpinner = function LoadingSpinner(_ref) {
  var iconClassname = _ref.iconClassname,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('flex items-center justify-center', className),
    children: /*#__PURE__*/_jsx("div", {
      className: clsx('border-brand-primary animate-spin rounded-full border-b-2 border-t-2', iconClassname, {
        'h-20 w-20': size === 'default',
        'h-4 w-4': size === 'sm'
      })
    })
  });
};
export function LoadingSpinnerV2(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('mr-2 h-4 w-4 animate-spin rounded-lg border-4 border-t-4 border-gray-200 border-t-transparent', className)
  });
}